import type {SVGProps} from 'react';

import * as React from 'react';
const YouTube = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    height="1em"
    viewBox="0 0 20 15"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <mask
        id="cutout"
        maskUnits="userSpaceOnUse"
      >
        <rect
          fill="white"
          height="15"
          width="20"
        />
        <path
          d="M7.5 12.4999L7.50779 3.33325L15 7.91658L7.5 12.4999Z"
          fill="black"
        />
      </mask>
    </defs>
    <path
      d="M17.9325 15H2.07472C0.928545 15 0 14.0083 0 12.7841V2.20816C0.00725426 0.991736 0.9358 0 2.07472 0H17.9253C19.0715 0 20 0.991736 20 2.21591V12.7918C20 14.0083 19.0715 15 17.9325 15Z"
      mask="url(#cutout)"
    />
  </svg>
);
export default YouTube;
